import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { OrderCustomJobComponent } from '@components/orders/manage-orders/production-flow/order-production-details/order-custom-job/order-custom-job.component';
import { OrderSpecificationBuilderComponent } from '@components/orders/manage-orders/production-flow/order-specification-builder/order-specification-builder.component';

import { singleOrderDetails } from '../../../../../@store/orders/orders.model';
import { SingleCaNumberDetails } from '../../../../../@store/products/ca-numbers/ca-numbers.model';

import { OrderConfirmChangeCaComponent } from './order-confirm-change-ca/order-confirm-change-ca.component';
import { OrderSpecificationDisplayComponent } from './order-specification-display/order-specification-display.component';

@Component({
  selector: 'ciwc-order-production-details',
  imports: [
    OrderSpecificationBuilderComponent,
    OrderCustomJobComponent,
    OrderSpecificationDisplayComponent,
  ],
  standalone: true,
  templateUrl: './order-production-details.component.html',
  styleUrl: './order-production-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderProductionDetailsComponent {
  @Input() parentForm!: FormGroup;
  @Input() details!: SingleCaNumberDetails;
  @Input() viewDisable!: boolean;
  @Input() orderDetails!: singleOrderDetails;
  @Input() itemProcesses: unknown[] = [];
  @Input() readonlySpecFields = false;

  constructor(
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {}

  onCaNumberSelected(caDetails: SingleCaNumberDetails) {
    // Update the details input which will trigger ngOnChanges in OrderSpecificationBuilderComponent
    this.details = caDetails;
  }

  openChangeCaModal() {
    this.dialog
      .open(OrderConfirmChangeCaComponent, {
        data: {
          caCustomDescription: this.parentForm.get('caCustomDescription')?.value,
        },
      })
      .afterClosed()
      .subscribe((result: boolean): void => {
        if (result) {
          // User confirmed the change, reset the CA number and custom description
          this.parentForm.get('caNumbersId')?.patchValue(null);
          this.parentForm.get('caCustomDescription')?.patchValue('');
          // Make sure to mark the form for check to update the UI
          this.cdr.markForCheck();
        }
      });
  }
}
